<div class="relative">
  @for (
    message of messages;
    track trackByFn(i, message);
    let first = $first;
    let last = $last;
    let i = $index
  ) {
    <div class="message-row">
      <div></div>
      @if (message["firstOfTheDay"] && message.sentOnUtc) {
        <div class="date-day staytop" [style.top.px]="isOnDND ? 50 : 10">
          <div class="date-line">
            <div class="date-bubble capitalize">
              {{ message.sentOnUtc | dateFormat: "relativeDay" }}
            </div>
          </div>
        </div>
      }
      <div>
        <app-messages-row
          [userAccount]="userAccount"
          [message]="message"
          [pMap]="pMap"
          [isFirstOfGroup]="
            !messages[i - 1] ||
            (i < messages.length &&
              messages[i].sentBy !== messages[i - 1].sentBy) ||
            (message['firstOfTheDay'] && message.sentOnUtc)
          "
          [searchQuery]="searchQuery"
          [conversationId]="conversationId"
          [conversationType]="conversationType"
          [patientId]="patientId"
          (selectMessage)="selectMessage.emit($event)"
          (quote_clicked)="quote_clicked.emit($event)"
          (forward)="forward.emit($event)"
          (copyMessage)="copyMessage.emit($event)"
          (delete)="delete.emit($event)"
          [fromSystem]="message.sentBy === 'SYSTEM'"
          [fromMe]="message.sentBy === userAccount.userId"
          [fromSender]="
            message.sentBy !== userAccount.userId && message.sentBy !== 'SYSTEM'
          "
          [isBlocked]="isBlocked"
          [isConversationAdmin]="isConversationAdmin"
          [isActiveParticipant]="isActiveParticipant"
        ></app-messages-row>
      </div>
    </div>
  }
</div>
